import React, { useContext, useState } from "react";
import Section from "../../../UIcomponent/Section";
import Col from "../../../UIcomponent/Column";
import "./TeachersCard.scss";
import LocalContext from "../../../Context/LocalContetxt";
import Image from "../../../UIcomponent/Image";
import { Rate } from "../../../UIcomponent/Rate";
import { ThemeContext } from "styled-components";
import TeachersCardDic from "./TeachersCardDic";
import Text from "../../../UIcomponent/Text";
import { PublicDic } from "../../../Utility/PublicDic";
import { CardTabList } from "./CardTabList";
import playButton from "../../../Assets/icon/playButton.svg";
import StyledLink from "../../../UIcomponent/Link";
// import AvatarDefault from "../../../Assets/images/AvatarDefault.jpg";
import { Title } from "../../../UIcomponent/Title";
import StyledAvatar from "../../../UIcomponent/StyledAvatar";
import Urls from "../../../Utility/Urls";
import AppConfig from "../../../Utility/Method/AppConfig";
import StarRoundedIcon from "@material-ui/icons/StarRounded";
import StyledButton from "../../../UIcomponent/Button";
import AparatPlayer from "../../../Component/AparatPlayer";
import { getGuid } from "../../../App";

const PlayIcon = () => {
  return <Image src={playButton} />;
};

const TeacherCard = (props) => {
  const theme = useContext(ThemeContext);
  const lang = useContext(LocalContext).lang;
  const [redirectState, setRedirectState] = useState({
    id: null,
    isRedirecting: false,
    showBookingModal: false,
  });
  let width = window.innerWidth;
  const videopPlayerRes = (width) => {
    switch (width) {
      case width > 1200:
        return "390px";
      case 900 < width < 1200:
        return "300px";
      default:
        break;
    }
  };
  const CategoryStr = (arr) => {
    let str = "";
    let CategoryList = [];
    arr.forEach((each, index) => {
      CategoryList.push(each);
    });
    str = `${CategoryList.join(" - ")}`;
    return (
      <Col
        xl={24}
        lg={24}
        md={24}
        sm={24}
        xs={24}
        className="o__Base__More__Content__Desc"
      >
        {str}
      </Col>
    );
  };
  // const scrollTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth"
  //   });
  // }

  let hasData = props.state.Results.length > 0;
  let initialData = [];
  let Data = hasData === true ? props.state.Results : initialData;
  Data.forEach((item, index) => {
    let kinds = "";
    Object.keys(item.AllowedCategories).forEach((category) => {
      if (item.AllowedCategories[category] == true) {
        kinds += "category,";
      }
    });
    if (window.ga) {
      window.ga("ec:addImpression", {
        id: item.TeacherID,
        name: `${item.FirstName} ${item.LastName}`,
        category: kinds,
        list: "Teacher list",
        position: index,
      });
    }
  });
  return (
    // <>
    // {
    Data.map((teacher, index) => {
      return (
        <Col
          xl={24}
          lg={24}
          md={24}
          sm={23}
          xs={23}
          height="auto"
          key={`${teacher.ID}`}
        >
          <Section
            width="100%"
            lang={lang}
            shadow="none"
            className="c__TeachersCard"
          >
            {/* <ReactPlayer
                style={{
                  // borderRadius : '15px',
                  outLine: "none"
                }}
                playing={false}
                // playsinline={true}
                controls={true}
                // playIcon={<PlayIcon />}
                autoPlay={false}
                height={!hasData ? '220px' : '220px'}
                width={videopPlayerRes(width)}
                volume={0.5}
                url={hasData && Urls.video() + teacher.IntroductionVideo}
              /> */}
            <Col
              className="c__TeachersCard__Info"
              borderRadius={
                lang === "fa" || lang === "ar"
                  ? "0px 15px 15px 0px"
                  : "15px 0px 0px 15px"
              }
              xl={14}
              lg={14}
              md={14}
              sm={24}
              xs={24}
            >
              <StyledLink
                // className='c__TeachersCard__Info--link'
                // onClick={(e) => cardBookClickHanlder(e, teacher.UserID, false)}
                // target='_blank'
                onClick={(_) => {
                  window.ga("ec:setAction", "click", {
                    id: getGuid(),
                    step: 1,
                    list: "teacher list",
                  });
                }}
                to={hasData && `/teacher/${teacher.PublicUsername}`}
                // to={null}
                // onClick={scrollTop}
              >
                <Col
                  className="o__TeachersCard__Status"
                  xl={7}
                  lg={6.5}
                  md={8}
                  sm={8}
                  xs={9}
                  flexDir="column"
                >
                  <Col className="c__Teachers__Status__Avatar">
                    <StyledAvatar
                      loading={!hasData}
                      className="o__Teachers__Status__Avatar"
                      alt={`${teacher.FirstName} ${teacher.LastName}`}
                      source={
                        teacher.UserAvatar !== "" &&
                        teacher.UserAvatar &&
                        Urls.avatar() +
                        (teacher.UserAvatar.includes(".jpg")
                          ? teacher.UserAvatar.split(".jpg").join(
                            "_thumb.jpg"
                          )
                          : teacher.UserAvatar.includes(".png")
                            ? teacher.UserAvatar.split(".png").join(
                              "_thumb.png"
                            )
                            : teacher.UserAvatar)
                      }
                    />
                  </Col>
                  <Col className="c__TeachersCard__Status__More">
                    <Col
                      xl={23}
                      lg={23}
                      md={23}
                      sm={23}
                      xs={23}
                      className="o__TeachersCrad__Status__More__Name--RES"
                      justifyContent="space-between"
                      skeletonType={"line"}
                      loading={!hasData}
                    >
                      {hasData === true &&
                      teacher.FirstName + " " + teacher.LastName}
                    </Col>
                    {teacher.Rate > 0 ? (
                      <>
                        <Col
                          xl={18}
                          lg={18}
                          md={18}
                          sm={18}
                          xs={18}
                          className="o__Teachers__Status__Rate"
                        >
                          <Rate
                            size="small"
                            allowHalf={true}
                            count={5}
                            icon={<StarRoundedIcon fontSize="inherit" />}
                            style={{
                              direction:
                                lang === "fa" || lang === "ar" ? "ltr" : "rtl",
                              color: theme.warning,
                              opacity: 1,
                            }}
                            // value={teacher.Rate}
                            value={
                              teacher.Rate.length > 1
                                ? teacher.Rate.toFixed(1)
                                : teacher.Rate
                            }
                            allowClear={false}
                            disabled={true}
                          />
                        </Col>
                        <Col className="o__Teachers__Status__RateValue">
                          {teacher.SessionCount +
                          " " +
                          TeachersCardDic.SessionCount[`${lang}`]}
                        </Col>
                      </>
                    ) : (
                      <Col
                        className="o__Teachers__Status__New"
                        loading={!hasData}
                      >
                        {hasData === true && "جدید"}
                      </Col>
                    )}
                    {hasData === true && (
                      <StyledButton
                        id={`teacherProfileReviewButton_${teacher.UserID}`}
                        primary
                        // onClick={(e) => cardBookClickHanlder(e, teacher.UserID, true)}
                      >
                        {/* <StyledLink
                            to={{
                              pathname: `/teacher/${teacher.ID}`,
                              state: { 'showBookingModal': 'true' }
                            }}
                          > */}
                        مشاهده پروفایل
                        {/* </StyledLink> */}
                      </StyledButton>
                    )}
                  </Col>
                  {/* <Col
                                    className='o__Teachers__Status__Session'
                                >
                                    10
                            <Text
                                        justifyContent='center'
                                    >
                                        {TeachersCardDic.session[`${lang}`]}
                                    </Text>
                                </Col> */}
                </Col>
                <Col
                  className="o__TeachersCard__Base"
                  xl={17}
                  lg={18.5}
                  md={18}
                  sm={16}
                  xs={15}
                  flexDir="column"
                  alignItems="flex-start"
                >
                  <Col
                    xl={23}
                    lg={23}
                    md={23}
                    sm={23}
                    xs={23}
                    className="o__Teachers__Base__Name"
                    justifyContent="space-between"
                    skeletonType="line"
                    loading={!hasData}
                  >
                    {hasData === true &&
                    teacher.FirstName + " " + teacher.LastName}
                  </Col>
                  <Col
                    xl={23}
                    lg={23}
                    md={23}
                    sm={23}
                    xs={23}
                    className="o__Teachers__Base__More"
                    flexWrap="wrap"
                  >
                    <Col
                      className="c__Teachers__Base__More__Content"
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      skeletonType="line"
                      loading={!hasData}
                    >
                      {hasData && (
                        <>
                          <Title>{TeachersCardDic.teacher[`${lang}`]}</Title>
                          <Col
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className="o__Base__More__Content__Desc"
                          >
                            {teacher.TeachingLanguages &&
                            AppConfig.Language(teacher.TeachingLanguages)[
                              `${lang}`
                              ]}
                          </Col>
                        </>
                      )}
                    </Col>
                    <Col
                      xl={24}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className="c__Teachers__Base__More__Content"
                      skeletonType="line"
                      loading={!hasData}
                    >
                      {hasData === true && (
                        <>
                          <Title>
                            {/* {TeachersCardDic.category[`${lang}`]} */}
                            مهارت ها
                          </Title>

                          {CategoryStr(
                            Object.keys(teacher.AllowedCategories)
                              .filter((key, index) => {
                                return teacher.AllowedCategories[key] === true;
                              })
                              .map(
                                (each) => AppConfig.Category(each)[`${lang}`]
                              )
                          )}
                        </>
                      )}
                    </Col>

                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="c__Teachers__Base__More__Content"
                      skeletonType="line"
                      loading={!hasData}
                    >
                      {hasData === true && (
                        <>
                          <Title>{TeachersCardDic.minPrice[`${lang}`]}</Title>
                          <Col
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            skeletonType="line"
                            loading={!hasData}
                            className="o__Base__More__Content__Desc"
                          >
                            {(teacher.MinPrice / 10).toLocaleString(lang) +
                            " " +
                            PublicDic.Toman}
                          </Col>
                        </>
                      )}
                    </Col>
                    <Col
                      xl={12}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      className="c__Teachers__Base__More__Content"
                    >
                      {hasData === true && (
                        <>
                          <Title>
                            {TeachersCardDic.tryOutClass[`${lang}`]}
                          </Title>
                          <Col
                            xl={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xs={24}
                            className="o__Base__More__Content__Desc"
                          >
                            {teacher.TrialPrice !== 0
                              ? (teacher.TrialPrice / 10).toLocaleString(lang) +
                              " " +
                              PublicDic.Toman
                              : "رایگان"}
                          </Col>
                        </>
                      )}
                    </Col>
                  </Col>
                </Col>
              </StyledLink>
            </Col>
            <Col
              className="c__TeachersCard__Options"
              flexDir="column"
              xl={10}
              lg={10}
              md={10}
              sm={18}
              xs={0}
              borderRadius={
                lang !== "fa" || lang === "ar"
                  ? "0px 15px 15px 0px"
                  : "15px 0px 0px 15px"
              }
            >
              <Col className="o__TeachersCard__Options__Title" height="auto">
                {hasData === true &&
                CardTabList.map((tab, i) => {
                  return (
                    <Text
                      key={i}
                      style={{
                        cursor: "pointer",
                      }}
                      className={
                        teacher.tab === i &&
                        "o__TeachersCard__Options__Tab--active"
                      }
                      onClick={() => props.TabHandle(index, i)}
                    >
                      {tab.name[`${lang}`]}
                    </Text>
                  );
                })}
              </Col>
              <Col
                className="o__TeachersCard__Options__Content"
                xl={18}
                lg={18}
                md={18}
                sm={18}
                xs={18}
                // style={{
                //   width: '360px'
                // }}
              >
                <Col
                  className="o__TeachersCard__Options__Content__VideoPlayer"
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  // height={'250px'}
                  style={{
                    display: teacher.tab === 1 && "none",
                    height: "202.5px",
                    minHeight: "202.5px",
                  }}
                  loading={!hasData}
                >
                  {hasData && (
                    <AparatPlayer
                      key={teacher.UserID}
                      baseUrl={Urls.baseUrl}
                      video={teacher.IntroAparat}
                      primary={theme.primary}
                      secondary={"white"}
                      overlay={theme.lightGlass}
                    />
                  )}
                  {/* <ReactPlayer
                    style={{
                      outLine: "none"
                    }}
                    id={`videoId-${teacher.UserID}`}
                    playsinline={false}
                    controls={true}
                    autoPlay={false}
                    preload={false}
                    height={!hasData ? '220px' : '220px'}
                    width={videopPlayerRes(width)}
                    // playing={teacher.videoPlaying}
                    // onPlay={() => props.PlayingHandler(teacher.UserID)}
                    volume={1}
                    url={hasData ? Urls.video() + teacher.IntroductionVideo : ''}
                  /> */}
                </Col>
                <Text
                  className="o__TeachersCard__Options__Content__Intro"
                  height="90%"
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  style={{
                    display: teacher.tab === 0 && "none",
                  }}
                >
                  {teacher.AboutMe}
                </Text>
              </Col>
            </Col>
          </Section>
        </Col>
      );
    })
  );
};

export default TeacherCard;
